import { ANY_VALUE_NUMBER_NUMERIC } from '../../Common/Constants/DefaultValues'

export const FILTER_LOCATION_ANY = -1
export const FILTER_LOCATION_FROM = 0
export const FILTER_LOCATION_TO = 1

// Filter options, for use within the comma-separated channel filter list that is used by the channel selection combo box within the Report Properties window.
export const FILTER_CHANNEL_TYPE_FILTER_OPTION_ANY = -1
export const FILTER_CHANNEL_TYPE_FILTER_OPTION_VOICE = 0
export const FILTER_CHANNEL_TYPE_FILTER_OPTION_CHAT = 1
export const FILTER_CHANNEL_TYPE_FILTER_OPTION_EMAIL = 2

export const FILTER_CALLTYPEDIRECTION_ANY = ANY_VALUE_NUMBER_NUMERIC
export const FILTER_CALLTYPEDIRECTION_UNKNOWNORINITIATING = 0
export const FILTER_CALLTYPEDIRECTION_INTERNAL_ALL = 1
export const FILTER_CALLTYPEDIRECTION_EXTERNAL_ALL = 2
export const FILTER_CALLTYPEDIRECTION_EXTERNAL_INBOUND = 3
export const FILTER_CALLTYPEDIRECTION_EXTERNAL_OUTBOUND = 4
export const FILTER_CALLTYPEDIRECTION_EXTERNAL_TRKTOTRK = 5
export const FILTER_CALLTYPEDIRECTION_INBOUND = 6
export const FILTER_CALLTYPEDIRECTION_OUTBOUND = 7
export const FILTER_CALLTYPEDIRECTION_INTERNAL_INBOUND = 8
export const FILTER_CALLTYPEDIRECTION_INTERNAL_OUTBOUND = 9

export const FILTER_ANSWER_TYPE_ANY = ANY_VALUE_NUMBER_NUMERIC
export const FILTER_ANSWER_TYPE_NOT_ANSWERED = 0
export const FILTER_ANSWER_TYPE_ANSWERED = 1
export const FILTER_ANSWER_TYPE_ABANDONED = 2
export const FILTER_ANSWER_TYPE_ADVANCED_FROM = 3
export const FILTER_ANSWER_TYPE_ADVANCED_TO = 4
export const FILTER_ANSWER_TYPE_OVERFLOWED_FROM = 5
export const FILTER_ANSWER_TYPE_OVERFLOWED_TO = 6

// Report CLI/CallerID type filter options.
export const FILTER_CLITYPE_ANY = -1
export const FILTER_CLITYPE_NONE = 0
export const FILTER_CLITYPE_RECEIVED = 1

export const MAX_DEVICES_AGENTS: number = 5000
